import React, { useState, useEffect, useRef } from "react";
import Breadcrumb from "./Breadcrumb";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Formik, FieldArray } from "formik";
import { ProductService } from "../../../services/product-service";
import { notify, notifyError, notifyWarning } from "../Toastmessage/Toastmessage";
import { ToastContainer } from "react-toastify";
import * as Yup from "yup";
import Select from "react-select";
import { OrderService } from "../../../services/order-service";
import { CustomerService } from "../../../services/customer-service";

export const Addordercontent = (props) => {

  const formRef = useRef();

  const [orderdate, setOrderDate] = useState("");

  const [submitloading, setSubmitLoading] = useState(true);


  const [products, setProductDetails] = useState([]);
  // const [provinces, setProvinces] = useState([]);
  // const [districts, setDistricts] = useState([]);
  // const [cities, setCities] = useState([]);

  const [users, setUsers] = useState([]);

  // const [deliveryarea, setDeliveryArea] = useState([]);
  // const [provinceId, setProvinceId] = useState(0);
  // const [districtId, setDistrictId] = useState(0);
  // const [cityId, setCityId] = useState(0);

  const [productId, setProductId] = useState("");

  const [quantity, setQuantity] = useState("");

  const [array, setArray] = useState([]);

  const [setTotal, setsetTotal] = useState(10);

  const [checkSendData, setCheckSendData] = useState(true);

  // const [selectedOption, setSelectedOption] = useState('');
  // const [typeCategories, setTypeCategories] = useState([]);
  // const [isVisible, setIsVisible] = useState(false);

  // const [selectedFiles, setSelectedFiles] = useState([]);
  // const [imagePreviews, setImagePreviews] = useState([]);

  //Show and hide file upload section
  // const handleOptionChange = (event) => {
  //   setSelectedOption(event.target.value);
  //   if(event.target.value === 'BANK_DEPOSIT'){
  //     setIsVisible(true);
  //   }else{
  //     setIsVisible(false);
  //   }
  // };

  //File upload handle
  // const handleFileChange = (e) => {
  //   const filesArray = Array.from(e.target.files);
  //   const previews = filesArray.map((file) => URL.createObjectURL(file));
  //   setImagePreviews(previews);
  //   setSelectedFiles({'files': e.target.files});
  // };

  let subTotal;
  let total = 0;

  // useEffect(() => {
  //   calculateSubTotal(productId, quantity)
      
  // }, [productId, quantity]);



    const foundProduct = products.filter((x) => (x.id === productId));
    if(quantity > 0){
      if(foundProduct[0].stock >= quantity){
        subTotal = foundProduct[0]?.price * quantity;
      }else{
        notifyError('Only '+foundProduct[0].stock + ' items in Stock.')
      }
    }

  useEffect(() => {
    if (subTotal !== 0 && quantity !== "") {
      array.push(subTotal);

      total = total + subTotal;
      subTotal = 0;

      setQuantity("");
    }
  }, [subTotal]);

  useEffect(() => {
    const data = array.reduce((por, index) => {
      return por + index;
    }, 0);

    setsetTotal(data);
  }, [array.length, array]);

  const myFunction = (index) => {
    array.splice(index);
    const data = array.reduce((por, index) => {
      return por + index;
    }, 0);

    setsetTotal(data);
  };

  const ProductDetails = products.map((product) => {
    const container = {};

    container["value"] = product.id;
    container["label"] = product.name;

    return container;
  });


  const userSearch = async () => {
    try {
      const result = await CustomerService.customerViewAll()
      setUsers(result);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const productSearch = async () => {
    try {
      const filter = [{"product_group_type": "single"}, {"stock": "instock"}]
      const result = await ProductService.productDetailsAllSearch(filter);
      setProductDetails(result.results);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  // const provincesDetails = async () => {
  //   try {
  //     const result = await LocationService.provinceDetails();
  //     setProvinces(result);
  //   } catch (err) {
  //     //toast
  //     if (err.response.data.message !== undefined) {
  //       notifyWarning(err.response.data.message);
  //     } else {
  //       notifyWarning("Something Wrong");
  //     }
  //   }
  // };

  // const districtsDetails = async () => {
  //   try {
  //     const result = await LocationService.districtDetails();

  //     if(provinceId !== 0){
  //       const result2 = await LocationService.provinceDetails();
  //       const getProvince = result2.filter((item) => item.name_en ===  provinceId)
  //       const relatedDistricts = result.filter((item) => item.province_id === getProvince[0].id)
  //       setDistricts(relatedDistricts);
  //       setDistrictDropdownDisable(false)
  //     }else{
  //       setDistricts(result);
  //     }
      
  //   } catch (err) {
  //     //toast
  //     if (err.response.data.message !== undefined) {
  //       notifyWarning(err.response.data.message);
  //     } else {
  //       notifyWarning("Something Wrong");
  //     }
  //   }
  // };

  // const citiesDetails = async () => {
  //   try {
  //     const result = await LocationService.cityDetails();

  //     if(districtId !== 0){
  //       const districtsResult = await LocationService.districtDetails();
  //       const getDistrict = districtsResult.filter((item) => item.name_en ===  districtId)
  //       const relatedCities = result.filter((item) => item.district_id === getDistrict[0].id);
        
  //       setCities(relatedCities);
  //       setCityDropdownDisable(false)
  //     }else{
  //       setCities(result);
  //     }
  //   } catch (err) {
  //     //toast
  //     if (err.response.data.message !== undefined) {
  //       notifyWarning(err.response.data.message);
  //     } else {
  //       notifyWarning("Something Wrong");
  //     }
  //   }
  // };

  // const onSubmitAddressForm = async (
  //   values,
  //   { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  // ) => {
  //   //todo extra validations
  //   setSubmitLoading(false);

  //   try {
  //     await UserLocationService.userLocationCreate(
  //       values.city,
  //       values.tag,
  //       values.address_line_1,
  //       values.address_line_2,
  //       values.landmark,
  //       mapdetails?.lng,
  //       mapdetails?.lat,
  //       user
  //     );
  //     formRef.current.resetForm();

  //     setSubmitLoading(true);
  //     notify("Success Add User Location");
  //     userLocationSearch();
  //     handleClose1();
  //   } catch (err) {
  //     setSubmitLoading(true);
  //     //show error toast
  //     if (err.response.data.message !== undefined) {
  //       notifyWarning(err.response.data.message);
  //       notifyWarning(err.response.data.message[0]);
  //     } else {
  //       notifyWarning("Something Wrong");
  //     }
  //   }
  // };

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    let filter = [];

    values.product_data.map((loca, index) => {
      if (loca.quantity > 0) {
      } else {
        filter.push(loca.quantity);
      }
    });

    if (filter.length > 0) {
      notifyWarning(
        "Please Check Product Quantity Can not be Zero , - or empty "
      );
    } else {
      setCheckSendData(true);

      values.product_data.forEach((pro, index) => {
        let item = [pro.product];

        if (item) {
          const data = values.product_data.filter(
            (el) =>
              el.product === item[0]
          );

          if (data.length > 1) {
            setCheckSendData(false);
            throw notifyWarning("Please Remove Duplicate Product ");
          } else {
          }
        } else {
        }
      });
      if (checkSendData) {
        //todo extra validations
        setSubmitLoading(false);

        try {
          await OrderService.orderCreate(values);

          setSubmitLoading(true);
          notify("Order successfully Created");
          formRef.current.resetForm();
          setFieldValue("order_date", "");
          setFieldValue("province", "");
          setFieldValue("district", "");
          setFieldValue("city", "");
          setCheckSendData(true);
          setsetTotal(0);
          // setDistrictDropdownDisable(true);
          // setCityDropdownDisable(true);
          // setImagePreviews(null);
        } catch (err) {
          setCheckSendData(true);
          setSubmitLoading(true);

          if (err.response.data.message !== undefined) {
            notifyWarning(err.response.data.message);
            if (
              err.response.data.errors &&
              Object.keys(err.response.data.errors) &&
              Object.keys(err.response.data.errors).length > 0
            )
              notifyWarning(JSON.stringify(err.response.data.errors));
          } else {
            notifyWarning("Something Wrong");
          }
        }
      }
    }
  };

  useEffect(() => {
    productSearch();
    // provincesDetails();
    userSearch();
  }, []);

  // useEffect(() => {
  //   districtsDetails();
  // }, [provinceId]);

  // useEffect(() => {
  //   citiesDetails()
  // }, [districtId])

  

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div>
          <ToastContainer />
        </div>
        <div className="col-md-12">
          <Breadcrumb />
        </div>

        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Add Order Form </h6>
            </div>
            <div className="ms-panel-body">
              <div className="row">
                <div className="col-sm-12">
                  <Formik
                    initialValues={{
                      order_date: "",
                      payment_method: "",
                      user: "",
                      email: "",
                      city: "",
                      district: "",
                      province: "",
                      special_delivery_instruction: "",
                      product_data: [],
                    }}
                    validationSchema={Yup.object().shape({
                      user: Yup.string().required("Required"),
                      email: Yup.string().required("Required"),
                      // city: Yup.string().required("Required"),
                      // district: Yup.string().required("Required"),
                      // province: Yup.string().required("Required"),
                      order_date: Yup.string().required("Required"),
                      payment_method: Yup.string().required("Required"),
                      product_data: Yup.array()
                        .required("Must have product_data") // these constraints are shown if and only if inner constraints are satisfied
                        .min(1, "Minimum of 1 product"),
                    })}
                    onSubmit={onSubmitForm}
                    innerRef={formRef}
                    render={({
                      errors,
                      handleBlur,
                      handleChange,
                      touched,
                      values,
                      submitForm,
                      isValid,
                      setFieldValue,
                    }) => (
                      <div>
                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">User</label>
                            <select
                                name="user"
                                className="form-control"
                                id="nameId"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.user}
                              >
                                <option value="">Select User</option>
                                {users.map((user) => {
                                  return(
                                    <option key={user.id} value={user.id}>{user.name}</option>
                                  )
                                })}
                            </select>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.user && errors.user}
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                                Email
                            </label>
                            <div className="input-group">
                              <input
                                name="email"
                                type="text"
                                className="form-control"
                                id="emailId"
                                placeholder="example@gmail.com"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.email && errors.email}
                            </div>
                          </div>
                        </div>
                        {/* <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom15">
                              Province
                            </label>
                            <select
                              name= "province"
                              className="form-control"
                              id="provinceId"
                              required
                              onChange={(event) => {
                                setFieldValue("province", event.target.value);
                                setProvinceId(event.target.value);
                              }}
                              onBlur={handleBlur}
                              value={values.province}
                            >
                              <option value="">Select Province</option>
                                {provinces.map((province, index) => {
                                  return (
                                    <option key={province.id} value={province.name_en}>
                                        {province.name_en}
                                    </option>
                                  );
                              })}            
                            </select>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.province && errors.province}
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom15">
                              District
                            </label>
                            <select
                              name= "district"
                              className="form-control"
                              id="districtId"
                              required
                              onChange={(event) => {
                                setFieldValue("district", event.target.value);
                                setDistrictId(event.target.value)
                              }}
                              onBlur={handleBlur}
                              value={values.district}
                              disabled={districtDropdownhide}
                            >
                              <option value="">Select District</option>
                                {districts.map((district, index) => {
                                  return (
                                    <option key={district.id} value={district.name_en}>
                                        {district.name_en}
                                    </option>
                                  );
                              })}            
                            </select>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.district && errors.district}
                            </div>
                          </div>
                        </div> 
                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom15">
                              City
                            </label>
                            <select
                              name= "city"
                              className="form-control"
                              id="cityId"
                              required
                              onChange={(event) => {
                                setFieldValue("city", event.target.value);
                                setCityId(event.target.value)
                              }}
                              onBlur={handleBlur}
                              value={values.city}
                              disabled={cityDropdownhide}
                            >
                              <option value="">Select City</option>
                                {cities.map((city, index) => {
                                  return (
                                    <option key={city.id} value={city.name_en}>
                                        {city.name_en}
                                    </option>
                                  );
                              })}            
                            </select>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.city && errors.city}
                            </div>
                          </div>
                        </div>*/}
                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom15">
                              Order Date
                            </label>
                            <div className="input-group">
                              <input
                                name="order_date"
                                type="date"
                                className="form-control"
                                id="order_date_ID"
                                placeholder="Valid From"
                                required
                                onBlur={handleBlur}
                                onChange={(e) => {
                                  setOrderDate(e.target.value);
                                  setFieldValue("order_date", e.target.value);
                                  // setUserTimeSlotDisable(false);
                                }}
                                value={values.order_date}
                              />
                            </div>

                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.order_date && errors.order_date}
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom15">
                              Special Delivery Instruction
                            </label>
                            <div className="input-group">
                              <input
                                name="special_delivery_instruction"
                                type="text"
                                className="form-control"
                                id="deliveryInstructionId"
                                placeholder=""
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.special_delivery_instruction}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.special_delivery_instruction && errors.special_delivery_instruction}
                            </div>
                          </div>
                          {/* <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom15">
                              Time Slot
                            </label>
                            <div className="input-group">
                              <select
                                name="time_slot"
                                className="form-control"
                                id="time_slot_id"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.time_slot}
                                disabled={timeslothide}
                              >
                                <option value="">Select Time Slot</option>

                                {timeslot.map((time, index) => {
                                  return time.time_slots.map(
                                    (timeslot, index) => {
                                      return (
                                        <option key={index} value={timeslot}>
                                          {timeslot}
                                        </option>
                                      );
                                    }
                                  );
                                })}
                              </select>
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.time_slot && errors.time_slot}
                            </div>
                          </div> */}
                        </div>
                        <label htmlFor="validationCustom25">Add Products</label>
                        <div
                          className="ms-panel ms-panel-fh"
                          style={{ backgroundColor: "#F2F3F4" }}
                        >
                          <div className="col-md-12 mb-3 ">
                            <FieldArray
                              name="product_data"
                              render={(arrayHelpers) => (
                                <div>
                                  {values.product_data.map((option, index) => (
                                    <div key={index}>
                                      <div className="form-row">
                                        <div className="col-md-3 mb-3 mt-2">
                                          <Select
                                            className="basic-single"
                                            name={`product_data[${index}].product`}
                                            options={ProductDetails}
                                            placeholder="Select Product"
                                            // value={values.value}
                                            onChange={(event) => {
                                              setProductId(event.value)
                                              setQuantity('');
                                              setFieldValue(
                                                `product_data.${index}.product`,
                                                event.value
                                              );
                                              array[index] = 0;
                                            }}
                                            onBlur={handleBlur}
                                          />
                                        </div>
                                        <div className="col-md-3 mb-3 mt-2">
                                          <div className="input-group">
                                            <input
                                              name={`product_data[${index}].quantity`}
                                              min="0"
                                              type="number"
                                              className="form-control"
                                              id="quantityID"
                                              placeholder="Quantity"
                                              required
                                              onChange={(event) => {
                                                array.splice(index);

                                                setQuantity(event.target.value);
                                                if (event.target.value == "") {
                                                  array[index] = 0;
                                                }
                                                setFieldValue(
                                                  `product_data[${index}].quantity`,
                                                  event.target.value
                                                );
                                              }}
                                              onBlur={handleBlur}
                                              // value={values.quantity}
                                            ></input>
                                          </div>
                                        </div>

                                        <div className="col-md-3 mb-3 mt-2">
                                          <div className="input-group">
                                            <input
                                              name={`product_data[${index}].note`}
                                              type="text"
                                              className="form-control"
                                              id="noteID"
                                              placeholder="Note"
                                              required
                                              onChange={handleChange}
                                              onBlur={handleBlur}

                                              // value={values.term}
                                            ></input>
                                          </div>
                                        </div>
                                        <div className="col-md-3 mb-3 mt-2">
                                          <div className="input-group">
                                            <input
                                              name={`product_data[${index}].price`}
                                              type="text"
                                              className="form-control"
                                              id="priceID"
                                              placeholder="Sub Total"
                                              required
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={("Rs.", array[index])}
                                              readOnly
                                            ></input>
                                          </div>
                                        </div>

                                        <div className="col-md-3 mb-3">
                                          <button
                                            type="button"
                                            className="ms-btn-icon btn-primary"
                                            name="button"
                                            onClick={() => {
                                              myFunction(index);
                                              arrayHelpers.remove(index);
                                            }}
                                            style={{
                                              marginBottom: "2vh",
                                              backgroundColor: "red",
                                            }}
                                          >
                                            -
                                          </button>
                                        </div>
                                        <hr
                                          width="100%;"
                                          color="red"
                                          size="10"
                                        ></hr>
                                      </div>
                                    </div>
                                  ))}
                                  <button
                                    type="button"
                                    className="ms-btn-icon btn-primary"
                                    name="button"
                                    onClick={() =>
                                      arrayHelpers.push({
                                        product: "",
                                        quantity: "",
                                        note: "",
                                        price: "",
                                      })
                                    }
                                    style={{
                                      marginBottom: "1vh",
                                      marginTop: "1vh",
                                    }}
                                  >
                                    +
                                  </button>
                                </div>
                              )}
                            />
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {errors.product_data}
                            </div>
                          </div>
                        </div>

                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <div style={{ fontWeight: "bold", color: "red" }}>
                              Total Amount :
                            </div>
                          </div>
                          <div
                            className="col-md-6 mb-3"
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            <div style={{ fontWeight: "bold", color: "red" }}>
                              {" Rs/ "}
                              {setTotal}
                            </div>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom15">
                              Payment Method
                            </label>
                            <div className="input-group">
                              <select
                                name="payment_method"
                                className="form-control"
                                id="payment_method_id"
                                required
                                onChange={(e) => {
                                  setFieldValue("payment_method", e.target.value);
                                  // handleOptionChange(e)
                                }}
                                onBlur={handleBlur}
                                value={values.payment_method}
                              >
                                <option value="">Select Payment Method</option>
                                <option value="PAYHERE">
                                  PAYHERE
                                </option>
                                <option value="BANK_DEPOSIT">
                                  BANK DEPOSIT
                                </option>
                                <option value="CASH_ON_DELIVERY">
                                  CASH ON DELIVERY
                                </option>
                              </select>
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.payment_method && errors.payment_method}
                            </div>
                          </div>
                        </div>
                        {/* {isVisible && (<>
                          {imagePreviews && (<div>
                            <label htmlFor="validationCustom08">
                                Upload Image
                            </label>

                            <div>
                              {imagePreviews.map((preview, index) => (
                                <img
                                  key={index}
                                  src={preview}
                                  alt={`Preview ${index}`}
                                  style={{ width: "100px", height: "100px", marginRight: "10px" }}
                                />
                              ))}
                            </div>   
                          </div>)}
                          <div className="mb-3 mt-2">
                              <input
                                type="file"
                                name="files"
                                multiple
                                onBlur={handleBlur}
                                onChange={(event) => {
                                  // setSelectedFiles(event.target.files);
                                  handleFileChange(event)
                                  setFieldValue("files", event.target.files);
                                }}
                              />

                              <div style={{ color: "red", fontSize: "12px" }}>
                                {touched.files && errors.files}
                              </div>
                          </div>
                        </>)} */}
                        <div className="col-md-12 mb-3">
                          <div className="col-md-2" hidden={submitloading}>
                            <div className="spinner spinner-7">
                              <div className="bounce1" />
                              <div className="bounce2" />
                              <div className="bounce3" />
                            </div>
                          </div>
                        </div>
                        <button
                          type="button"
                          className="btn btn-primary shadow-none float-right"
                          onClick={() => {
                            submitForm();
                            setCheckSendData(true);
                          }}
                        >
                          Add Order
                        </button>
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addordercontent;
